<template>
	<div>
		<div class="sidebar-wrapper">
			<div class="logo">
				<div href="#" class="simple-text"></div>
			</div>
			<slot></slot>
			<ul>
				<router-link v-for="(link,index) in sidebarLinks" :to="link.path" tag="li" :ref="link.name">
					<a>
						<i :class="link.icon"></i>
						<p>{{link.name}}</p>
					</a>
				</router-link>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			sidebarLinks: {
				type: Array,
				default: () => []
			}
		},

		components: {
			
		},

		computed: {
			
		},

		data () {
			return {
				activeLinkIndex: 0,
				windowWidth: 0,
				isWindows: false,
				hasAutoHeight: false
			}
		},
		methods: {
			findActiveLink () {
				this.sidebarLinks.find((element, index) => {
					let found = element.path === this.$route.path
					if (found) {
						this.activeLinkIndex = index
					}
					return found
				})
			}
		},

		mounted () {
			this.findActiveLink()
		},

		watch: {
			$route: function (newRoute, oldRoute) {
				this.findActiveLink()
			}
		}
	}
</script>



// WEBPACK FOOTER //
// SideBar.vue?6961eef6